import { AppVersion, THEME_DARK } from '@cibo/ui'
import { Box, Button, Container, Stack, ThemeProvider, Typography } from '@mui/material'
import { ROUTE } from 'navigation/types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const Footer = () => {
  const { t } = useTranslation('impact/components/DrawerLayout/Footer')
  return (
    <Box sx={{ backgroundColor: 'primary.dark' }}>
      <Container>
        <ThemeProvider theme={THEME_DARK}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            py={1}
          >
            <Button
              variant="text"
              component={Link}
              size="small"
              to={ROUTE.TERMS_OF_USE}
              target="_blank"
              sx={{ color: 'primary.contrastText' }}
            >
              {t('termsAndConditions')}
            </Button>

            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="caption" sx={{ textAlign: 'center' }}>
                {t('copyright', { year: new Date().getFullYear() })}
              </Typography>
              <AppVersion variant="caption" />
            </Stack>
          </Stack>
        </ThemeProvider>
      </Container>
    </Box>
  )
}
